<template>
  <el-collapse v-model="activeName" accordion class="material-list-collapse">
    <el-collapse-item
      v-for="material in materialList"
      :key="material.id"
      :name="material.index"
      class="material-list-collapse-item"
    >
      <template slot="title">
        <div class="material-title">
          <i class="el-icon-document material-title-icon"></i>
          <span class="title-text">{{ material.name }}</span>
        </div>
      </template>
      <div class="material-content">
        <div class="material-content-description">Material Description:</div>
        <MarkdownDisplay :value="material.description"/>
        <FileDownloadCard v-if="material.attachment" :href="material.attachment" />
        <div class="material-content-teacher-section"></div>
      </div>
      <div class="button-group">
        <el-button
          type="danger"
          v-if="$store.state.userPower === 'A'"
          round
          @click="handleDelete(material)"
        >Delete</el-button>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import { deleteMaterialById } from "@/api/materials.js";

export default {
  name: "MaterialList",
  components: {
    MarkdownDisplay,
    FileDownloadCard
  },
  data() {
    return {
      activeName: "1"
    };
  },
  props: {
    materialList: Array
  },
  methods: {
    handleDelete: function(material) {
      this.$confirm(
        `Delete material "${material.name}". Are you sure?`,
        "Warning",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          deleteMaterialById(material.id).then(res => {
            if (res === "succeed") {
              this.$message({
                type: "success",
                message: "Delete Success!"
              });
              this.$emit("refresh-list");
            } else {
              this.$message({
                type: "error",
                message: "Network error. Please try again."
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.material-list-collapse {
  border: none !important;
}
.material-list-collapse-item {
  margin: 8px 0;
  border-radius: 12px;
  overflow: hidden;
  &:hover,
  &:focus,
  &.is-active {
    box-shadow: 0 0 5px #909399;
  }
  * {
    border: none !important;
  }
}
.el-collapse-item__header {
  padding: 8px 16px;
  &.is-active {
    background-color: #e4f7fb;
  }
  .material-title {
    flex-grow: 1;
    display: flex;
    .material-title-icon {
      line-height: inherit;
      padding-right: 12px;
    }
    .title-text {
      font-size: 16px;
      font-weight: 600;
      flex-grow: 1;
    }
  }
}
.material-content {
  padding: 8px 16px;
  .material-content-description {
    font-size: 14px;
    margin-bottom: 8px;
    color: #a2a2a2;
  }
}
.button-group {
  padding: 8px 16px;
  text-align: right;
  > * {
    margin-left: 16px;
  }
}
</style>